export {
  renderGlyphTabIcon,
  type GlyphTabIconImage,
  type GlyphTabIconRun,
} from "#render-glyph-tab-icon";
